/* eslint-disable no-console */
/* eslint-disable quote-props */

const humanFriendlyEventNames = {
  'cartpage-nosto-1': 'Push Cart Nosto',
  'frontpage-nosto-3': 'Homepage Nosto',
  'productpage-nosto-1': 'PDP Nosto',
  product_card_atc: 'Product Card ATC',
  product_page_atc: 'Product Page ATC',
  secure_checkout: 'click checkout securely cta',
}

function init () {
  observeForTrackingAttributes()

  document.querySelectorAll('[data-ab-tasty-atc]').forEach(quickAdd => {
    quickAdd.addEventListener('click', sendABClickEvent)
  })
}

function observeForTrackingAttributes () {
  const callback = mutationsList => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          const targetNode =
            node.nodeType === 1 && node.matches('[data-ab-tasty-atc]')
              ? node
              : node.querySelector
                ? node.querySelector('[data-ab-tasty-atc]')
                : null

          if (targetNode) {
            targetNode.addEventListener('click', sendABClickEvent)
          }
        })
      }
    }
  }

  const observer = new MutationObserver(callback)

  const config = { childList: true, subtree: true }

  observer.observe(document.body, config)
}

function sendABClickEvent (event) {
  console.log('Clicked element with data-ab-tasty-atc')

  const hasSource = event.currentTarget.closest('[data-source]')

  if (hasSource) {
    event.currentTarget.setAttribute(
      'data-ab-tasty-atc',
      hasSource.dataset.source,
    )
  }

  if (
    event.currentTarget.getAttribute('data-ab-tasty-atc') in
    humanFriendlyEventNames
  ) {
    event.currentTarget.setAttribute(
      'data-ab-tasty-atc',
      humanFriendlyEventNames[
        event.currentTarget.getAttribute('data-ab-tasty-atc')
      ],
    )
  }

  console.log(
    'sent this event to the AB data layer:',
    event.currentTarget.dataset.abTastyAtc,
  )
  window.ABTastyClickTracking(event.currentTarget.dataset.abTastyAtc, [null])
}

init()
